import React from 'react';

import { BackupLenderGlobalNav } from '~/backup/lender/domains/page/ui/BackupLenderGlobalNav';
import { BackupOriginatorGlobalNav } from '~/backup/originator/domains/page/ui/BackupOriginatorGlobalNav';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { CoreGlobalNav } from '~/core/CoreGlobalNav';

export const UserAwareGlobalNav = ({
  isFixed = false,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  const { user } = useUserAuthOrThrow();

  if (user.userType === 'BACKUP_LENDER')
    return <BackupLenderGlobalNav isFixed={isFixed} />;
  if (user.userType === 'BACKUP_ORIGINATOR')
    return <BackupOriginatorGlobalNav isFixed={isFixed} />;
  return <CoreGlobalNav isFixed={isFixed} />;
};
